import { EEAuthStepsPages } from 'App';
import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';

const EEAuthSteps = () => <EEAuthStepsPages />;

export default EEAuthSteps;
